export default __webpack_public_path__ + "static/media/offer2-app.c15ef976.mp4";